import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { changeEventQueryFor, GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { SelectConfigurationStep } from "../1.SelectConfigurationStep";
import {
  applyConfigurationFormConfig,
  ApplyConfigurationFormInput,
  applyConfigurationMapToForm,
} from "../applyConfigurationForm";
import { ReviewConfigurationStep } from "../ReviewConfigurationStep";
import { ReviewImpactStep } from "../ReviewImpactStep";
import { useApplyConfigurationActions } from "../useSaveApplyConfigurationChangeEvent";
import { SelectChangesStep } from "./2.SelectChangesStep";

export const applyPartialConfigurationWorkflow = defineWorkflow<ApplyConfigurationFormInput>({
  workflow: ChangeEventWorkflow.ApplyPartialConfiguration,
  formConfig: applyConfigurationFormConfig,
  mapToForm: applyConfigurationMapToForm,
  steps: [
    {
      value: GuidedChangeEventStep.SelectConfiguration,
      label: "Select New Config",
      isComplete: (form) => !!form.targetConfigId.value,
      render: (form, project) => <SelectConfigurationStep formState={form} project={project} />,
    },
    {
      value: GuidedChangeEventStep.SelectChanges,
      label: "Select Changes",
      isComplete: (form) => form.optionIds.valid,
      disabled: (form) => !form.configChangeId.value,
      render: (form) => <SelectChangesStep formState={form} />,
    },
    {
      value: GuidedChangeEventStep.ReviewConfiguration,
      label: "Review Configuration",
      isComplete: (form) => form.optionIds.valid,
      disabled: (form) => !form.configChangeId.value,
      render: (form) => <ReviewConfigurationStep formState={form} />,
    },
    {
      value: GuidedChangeEventStep.ReviewImpact,
      label: "Review Impact",
      isComplete: (form) => !!form.targetConfigId.value && form.optionIds.valid,
      disabled: (form) => !changeEventQueryFor(form).changeEventId || form.optionIds.dirty,
      render: (form) => <ReviewImpactStep formState={form} />,
    },
    reviewStep(),
  ],
  useActions: useApplyConfigurationActions,
});
